import { render, staticRenderFns } from "./ServicesStatsDetail.vue?vue&type=template&id=33def24e&scoped=true&"
import script from "./ServicesStatsDetail.vue?vue&type=script&lang=ts&"
export * from "./ServicesStatsDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ServicesStatsDetail.vue?vue&type=style&index=0&id=33def24e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33def24e",
  null
  
)

export default component.exports